<template>
  <Walkthrough 
    roomName="Auto"
    roomKey="car"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="italian"
  />
</template>
<script>

export default {
  name: 'Car',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/car-1920x1280.jpg",
      steps: [
            "Guarda a destra e ispeziona il sedile. Dovresti trovare un cacciavite.",
            "Guarda su e utilizza il tuo cacciavite sulla luce. Dopo aver svitato la luce dovresti trovare dentro un coltello.",
            "Guarda giù e utilizza il tuo coltello sulla cintura di sicurezza. Dovrebbe tagliarla e liberarti, permettendoti di muoverti liberamente nella parte frontale dell'auto.",
            "Guarda a sinistra e ispeziona il portabicchieri. Sembra che qualcuno abbia fatto un errore e ti abbia lasciato una chiave.",
            "Guarda davanti e utilizza il tuo cacciavite sul cruscotto. Così dovresti rimuovere il cruscotto e rivelare un mucchio di cavi.",
            "Sempre guardando davanti, utilizza la chiave sul vano portaoggetti. La chiave lo sbloccherà e troverai del nastro isolante e del testo sul manuale dentro di esso.",
            "Utilizzando il messaggio trovato nel manuale, sai quali cavi non usare. Ricorda questo. ",
            "Ora che hai i colori per collegare i cavi elettrici, usa il nastro elettrico sui fili e collega i fili verde, arancione, nero e blu. Dovrebbe tornare l'alimentazione dell'auto!",
            "Guarda giù e ispeziona il tappeto. Nota come la targa ha numeri romani che indicano 2415. Questo è il codice per la cassaforte!",
            "Guardando davanti, inserisci il codice 2415 nella cassaforte, e quando si apre dovresti trovare una mazza dentro.",
            "Usa la mazza sul parabrezza per spaccarlo e scappare verso la libertà! Prova a scappare dalla prossima stanza da solo!"

             ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/it/car.vue